var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThermometer = function SvgThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.954 1.5a3.371 3.371 0 0 0-3.37 3.371v8.338l-.253.212a5.456 5.456 0 1 0 6.994-.212V4.872a3.371 3.371 0 0 0-3.37-3.372Zm-1.87 3.371a1.872 1.872 0 1 1 3.741 0v8.72c0 .25.124.483.332.622a3.956 3.956 0 1 1-4.405 0 .75.75 0 0 0 .332-.622V4.87Zm1.83 11.35a1.15 1.15 0 1 0 .06 2.3 1.15 1.15 0 0 0-.06-2.3Zm.779-1.392a2.65 2.65 0 1 1-1.5 0V9.206a.75.75 0 0 1 1.5 0v5.623Z",
    fill: "#0075C9"
  })));
};
export default SvgThermometer;